var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5896 0.410826C11.915 0.736263 11.915 1.2639 11.5896 1.58934L7.17883 6.00009L11.5896 10.4108C11.915 10.7363 11.915 11.2639 11.5896 11.5893C11.2641 11.9148 10.7365 11.9148 10.4111 11.5893L6.00032 7.1786L1.58958 11.5893C1.26414 11.9148 0.736507 11.9148 0.41107 11.5893C0.0856329 11.2639 0.0856329 10.7363 0.41107 10.4108L4.82181 6.00009L0.411071 1.58935C0.0856337 1.26391 0.0856338 0.736272 0.411071 0.410835C0.736508 0.0853979 1.26415 0.0853979 1.58958 0.410835L6.00032 4.82158L10.4111 0.410826C10.7365 0.0853888 11.2641 0.0853888 11.5896 0.410826Z",
    fill: "#149CCE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.41a197bef1b5fa85d89d12bc6050209f.svg";
export { ForwardRef as ReactComponent };